export const card = {
  card: {
    root: {
      borderRadius: '3px',
    },
  },
};
